import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, unref as _unref, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b9f828e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-column flex-lg-row" }
const _hoisted_2 = { class: "flex-column flex-lg-row-auto w-100 w-lg-400px w-xl-400px mb-10 mb-lg-0 report-list-container" }
const _hoisted_3 = { class: "card" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, "Equity Report Types")
], -1))
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = {
  key: 0,
  class: "align-middle"
}
const _hoisted_7 = {
  key: 1,
  class: "align-middle"
}
const _hoisted_8 = {
  key: 2,
  class: "report-list"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "flex-lg-row-fluid ms-lg-7 ms-xl-10" }
const _hoisted_12 = { class: "card" }
const _hoisted_13 = { class: "card-header" }
const _hoisted_14 = { class: "card-title" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Equity Report", -1))
const _hoisted_16 = { class: "ms-4" }
const _hoisted_17 = { class: "card-body" }
const _hoisted_18 = { class: "table align-middle table-row-dashed fs-6 gy-5" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }, [
    /*#__PURE__*/_createElementVNode("th", null, "Currency"),
    /*#__PURE__*/_createElementVNode("th", null, "Office"),
    /*#__PURE__*/_createElementVNode("th", null, "Number of Accounts"),
    /*#__PURE__*/_createElementVNode("th", null, "Action")
  ])
], -1))
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { key: 2 }

import { onMounted, ref, computed } from "vue";
import LoadingCentralBox from "@/components/LoadingCentralBox.vue";
import NoDataCentralBox from "@/components/NoDataCentralBox.vue";
import { Search } from "@element-plus/icons-vue";
import ReportService from "../services/ReportService";
import AccountInfo from "../components/equityReport/AccountInfo.vue";
import EditReportInfo from "../components/equityReport/EditReportInfo.vue";
import notification from "@/core/plugins/notification";

export default /*#__PURE__*/_defineComponent({
  __name: 'EquityReportIndex',
  setup(__props) {

const isLoadingTypes = ref(false);
const isLoadingReportData = ref(false);
const reportTypes = ref<any>([]);
const reportData = ref<any>([]);

const accountInfoRef = ref<any>(null);
const editReportInfoRef = ref<any>(null);
const idSelected = ref(null);
const accountNumber = ref<any>(null);
const tableColId = ref(null);
const selectBackground = (id) => {
  idSelected.value = id;
};

const searchAccountData = async () => {
  if (accountNumber.value) {
    accountInfoRef.value.show(accountNumber.value);
  }
};

const showEditReportInfo = () => {
  editReportInfoRef.value.show();
};

const showReports = async (item) => {
  isLoadingReportData.value = true;
  // try{
  //     const response = await ReportService.queryEquityReport(item.id);
  //     reportData.value = response.data;
  // } catch (error) {
  //     console.log(error);
  //     notification.danger();
  // }
  isLoadingReportData.value = false;
};

const fecthReportTypes = async () => {
  isLoadingTypes.value = true;
  // try{
  //     const response = await ReportService.queryEquityReportTypes();
  //     reportTypes.value = response.data;
  // } catch (error) {
  //     console.log(error);
  //     notification.danger();
  // }
  isLoadingTypes.value = false;
};

onMounted(async () => {
  await fecthReportTypes();
});

return (_ctx: any,_cache: any) => {
  const _component_FileIcon = _resolveComponent("FileIcon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            (isLoadingTypes.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(LoadingCentralBox)
                ]))
              : (!isLoadingTypes.value && reportTypes.value.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createVNode(NoDataCentralBox)
                  ]))
                : (_openBlock(), _createElementBlock("ul", _hoisted_8, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reportTypes.value, (item) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: item.id,
                        class: _normalizeClass({
                'selected-background': item.id === idSelected.value,
              }),
                        onClick: ($event: any) => (selectBackground(item.id))
                      }, [
                        _createVNode(_component_FileIcon, {
                          type: item.type
                        }, null, 8, ["type"]),
                        _createElementVNode("a", {
                          href: "#",
                          onClick: _withModifiers(($event: any) => (showReports(item)), ["prevent"])
                        }, _toDisplayString(item.title), 9, _hoisted_10)
                      ], 10, _hoisted_9))
                    }), 128))
                  ]))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("h3", _hoisted_14, [
              _hoisted_15,
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_el_input, {
                  modelValue: accountNumber.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((accountNumber).value = $event)),
                  placeholder: "Account Number",
                  clearable: "",
                  disabled: isLoadingReportData.value,
                  onOnkeyup: searchAccountData,
                  onClick: searchAccountData
                }, {
                  append: _withCtx(() => [
                    _createVNode(_component_el_button, { icon: _unref(Search) }, null, 8, ["icon"])
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled"])
              ]),
              _createVNode(_component_el_button, {
                type: "primary",
                class: "ms-4",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (accountInfoRef.value.show()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" test ")
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("table", _hoisted_18, [
              _hoisted_19,
              (isLoadingReportData.value)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_20, [
                    _createVNode(_component_LoadingRing)
                  ]))
                : (!isLoadingReportData.value && reportData.value.length === 0)
                  ? (_openBlock(), _createElementBlock("tbody", _hoisted_21, [
                      _createVNode(_component_NoDataBox)
                    ]))
                  : (_openBlock(), _createElementBlock("tbody", _hoisted_22, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reportData.value, (item, index) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: index,
                          class: _normalizeClass({
                  'tr-select': item.id === tableColId.value,
                })
                        }, [
                          _createElementVNode("td", null, _toDisplayString(item.currency), 1),
                          _createElementVNode("td", null, _toDisplayString(item.office), 1),
                          _createElementVNode("td", null, _toDisplayString(item.numberOfAccounts), 1),
                          _createElementVNode("td", null, [
                            _createVNode(_component_el_button, {
                              type: "primary",
                              size: "mini",
                              onClick: showEditReportInfo
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("action.edit")), 1)
                              ]),
                              _: 1
                            })
                          ])
                        ], 2))
                      }), 128))
                    ]))
            ])
          ])
        ])
      ])
    ]),
    _createVNode(AccountInfo, {
      ref_key: "accountInfoRef",
      ref: accountInfoRef
    }, null, 512),
    _createVNode(EditReportInfo, {
      ref_key: "editReportInfoRef",
      ref: editReportInfoRef
    }, null, 512)
  ], 64))
}
}

})